export class AllPossibleMatchingModel {
    public id: number;
    public tuningName: string;
    public hitRate: number;
    public versionDateUploaded: string;
    public versionId: number;
    public masterId: number;
    public versionWinOlsReference: string;
    public dateMatched: string;
    public pureOriginalBaseId: number;

    constructor() {
        this.id = 0;
        this.tuningName = "tuningName";
        this.hitRate = 0;
        this.versionDateUploaded = "versionDateUploaded";
        this.versionId = 0;
        this.masterId = 0;
        this.versionWinOlsReference = "versionWinOlsReference";
        this.dateMatched = "dateMatched";
        this.pureOriginalBaseId = 0;
    }
}
